import { HugeiconsIcon } from "@hugeicons/react";
import { MailValidation01Icon } from "@hugeicons-pro/core-solid-rounded";
import { Button, ButtonVariant } from "shared/components";

type SignedStepProps = {
  onNext: () => void;
};

export const SignedStep = ({ onNext }: SignedStepProps) => {
  return (
    <>
      <div className="h-[calc(80vh-72px)] flex flex-col gap-6 items-center justify-center overflow-y-auto">
        <HugeiconsIcon
          icon={MailValidation01Icon}
          size={48}
          className="text-primary-500"
        />
        <div className="w-[410px] space-y-2">
          <p className="text-xl font-bold text-content-1000 text-center">
            Disclosure was signed
          </p>
          <p className="text-base text-content-400 text-center">
            You can review disclosure in the reports
          </p>
        </div>
      </div>
      <div className="h-20 border-t border-alpha-100 bg-white gap-2 flex justify-end items-center pr-4">
        <Button
          tooltipZIndex={51}
          variant={ButtonVariant.PRIMARY}
          className="w-[125px]"
          onClick={onNext}
        >
          Continue
        </Button>
      </div>
    </>
  );
};
